/*
 * The service raises machine-readable codes so the tablet can say something
 * useful to a concierge who is standing next to the car.
 */
const MESSAGES = [
  [
    /VALET_SESSION_REQUIRES_PLATE/,
    "This booking has no usable plate, so it cannot join the valet queue. Add the plate first.",
  ],
  [/VALET_SESSION_NOT_FOUND/, "This car is no longer in the valet queue."],
  [
    /VALET_SESSION_STATUS_CONFLICT/,
    "Another runner got to this car first - the queue has been refreshed.",
  ],
  [
    /VALET_SESSION_NOT_PARKED/,
    "This car is not on the lot right now, so it cannot be called up.",
  ],
  [
    /VALET_LOT_TYPE_MISMATCH/,
    "This guest card is for a different kind of car park - an offsite card parks offsite, an onsite card on site. Choose a car park the card allows.",
  ],
  [
    /VALET_LOT_NOT_FOUND/,
    "That car park is not one of this facility's - the queue has been refreshed.",
  ],
  [
    /PAYMENT_OUTSTANDING/,
    "This car has an unpaid balance. Ask concierge to clear outstanding payments before releasing it.",
  ],
  [
    /OUTSIDE_SHIFT_HOURS/,
    "Collections are paused right now - no runner is on shift to collect this car.",
  ],
  [
    /ALREADY_CONFIRMED/,
    "This booking has already been confirmed as posted to the room.",
  ],
  [
    /CHARGEBACK_NOT_FOUND/,
    "That chargeback is no longer available. Refresh the list and try again.",
  ],
  [
    /VALET_REPEAT_SESSION_NOT_ELIGIBLE/,
    "This booking cannot take another valet session - check the stay's end date and rate card.",
  ],
  [
    /VALET_SESSION_ALREADY_ACTIVE/,
    "This car is already with the valet.",
  ],
  [
    /VALET_SESSION_RUNNER_BUSY/,
    "That runner already has a car in hand. It has to reach its guest before the next set of keys comes off the rack.",
  ],
  [/BOOKING_NOT_FOUND/, "The booking for this car is already active or does not exist."],
  [/VEHICLE_PHOTO_TOO_LARGE/, "That photo is too large to upload. Retake it."],
  [
    /VEHICLE_PHOTO_NOT_UPLOADED/,
    "That photo never reached storage. Retake it.",
  ],
  [
    /VEHICLE_PHOTO_CONTENT_TYPE_MISMATCH/,
    "That photo did not store correctly. Retake it.",
  ],
  [
    /VEHICLE_PHOTO_KEY_MISMATCH/,
    "That photo could not be saved against this booking. Retake it.",
  ],
  [
    /Unsupported photo type/,
    "That image format cannot be uploaded. Use the camera to retake it.",
  ],
  [
    /UPLOAD_NETWORK_ERROR/,
    "The photo could not reach storage. Check the tablet's connection and retry.",
  ],
  [
    /UPLOAD_FAILED_403/,
    "Storage rejected the photo - the upload link expired. Retake it.",
  ],
  [/UPLOAD_FAILED_/, "Storage rejected the photo. Retry, or retake it."],
];

export function friendlyValetError(err, action = "accept the keys") {
  const raw =
    err?.graphQLErrors?.[0]?.message ||
    err?.networkError?.result?.errors?.[0]?.message ||
    err?.message ||
    "";

  for (const [pattern, message] of MESSAGES) {
    const match = raw.match(pattern);
    if (match) return typeof message === "function" ? message(match) : message;
  }

  return raw
    ? `Could not ${action}: ${raw.replace("GraphQL error: ", "")}`
    : `Could not ${action}. Try again.`;
}

export default friendlyValetError;
